"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _griditem = _interopRequireDefault(require("../griditem/griditem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries

/* ++++++++++ --------------- GRIDSET : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'GridSet',
  props: {
    direction: {
      type: 'string',
      default: 'vertical',
      options: ['vertical', 'horizontal']
    },
    children: {
      type: 'object',
      default: _react.default.createElement(_griditem.default, null, "Item1")
    }
  }
};
exports.default = _default;